import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import HoaDonApi from "service/hoaDonApi";

export const ModalHuyHoaDon = (props) => {
  const [lyDoHuy, setLyDoHuy] = useState("");
  const [isActiveSubmit, setIsActiveSubmit] = useState(false);

  const handleConfirm = async () => {
    if (!lyDoHuy.trim()) {
      pushNotification("Vui lòng nhập lý do hủy!", "warning", "TOP_CENTER", 2000);
      return;
    }
    setIsActiveSubmit(true);
    try {
      const response = await HoaDonApi.huyHoaDon(props.thuChiId, lyDoHuy);
      if (response.data?.Error === 1) {
        pushNotification(response.data.Message || "Lỗi khi hủy hóa đơn", "error", "TOP_CENTER", 3000);
      } else {
        pushNotification("Hủy hóa đơn thành công", "success", "TOP_CENTER", 2000);
        setLyDoHuy("");
        props.onHide();
      }
    } catch (error) {
      pushNotification(error.message || "Lỗi khi hủy hóa đơn", "error", "TOP_CENTER", 3000);
    } finally {
      setIsActiveSubmit(false);
    }
  };

  const handleHide = () => {
    setLyDoHuy("");
    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-cancel"></i>
          </span>
          Hủy hóa đơn
        </h4>
        <button type="button" className="close-popup-new" onClick={handleHide}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form form-horizontal">
          <div className="form-body">
            <div className="form-group row">
              <label className="col-md-4 label-control text-left">
                Lý do hủy <span className="red">*</span>
              </label>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nhập lý do hủy..."
                  value={lyDoHuy}
                  onChange={(e) => setLyDoHuy(e.target.value)}
                />
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {!isActiveSubmit && (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={handleConfirm}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>
        )}
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={handleHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
